import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { updateRoom, getRoomDataWithId, getBedsList, getRoomSizeType } from "adminApi/RoomApi/Room";
import { validateForm } from "utils/validation";
import { RoomRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import fields from "../json/RoomFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";
import EditRoomForm from "./Components/EditRoomForm";

const EditRoom = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(initialValues, RoomRules);

    // Fetch existing record by ID and populate form
    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getRoomDataWithId, setValues);

    // Fetch dropdowns in parent — not inside the form component
    const { data: roomTypeOptions, loading: loadingRoomType } = useFetchAllData(getRoomSizeType);
    const { data: bedTypeOptions, loading: loadingBedType } = useFetchAllData(getBedsList);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        // Send plain JSON — no file uploads in this form
        async (formValues) => await updateRoom({ id, data: formValues }),
        (vals) => {
            const err = validateForm(vals, RoomRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Room updated successfully"
    );

    return (
        <>
            {(loadingFetch || loadingSubmit || loadingRoomType || loadingBedType) && (
                <Spinner isSpinner={true} />
            )}
            <EditRoomForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => {
                    const sanitized = { ...values };
                    if (sanitized.exbed_capability !== "1") {
                        sanitized.exbed_capability_limit = 0;
                    }
                    handleSubmit(e, sanitized);
                }}
                loading={loadingSubmit}
                roomTypeOptions={roomTypeOptions || []}
                bedTypeOptions={bedTypeOptions || []}
                title="Edit Room"
            />
        </>
    );
};

export default EditRoom;
